module.exports = __webpack_public_path__ + "img/Seite24.6b160357.png";